import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=8fa3762e&"
import script from "./EditProduct.vue?vue&type=script&lang=ts&"
export * from "./EditProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports